function Footer() {
   const currentYear = new Date().getFullYear();

   return (
      <footer className="footer">
         <div className="footer__body">
            <p>
               &copy; {currentYear}{" "}
               <a href="https://instruireauto.site" className="footer__link">
                  Instruire Auto
               </a>{" "}
               • Powered by{" "}
               <a
                  href="https://zotaris.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Zotaris"
                  className="footer__brand"
                  title="Zotaris"
               >
                  <svg
                     width="131"
                     height="26"
                     viewBox="0 0 131 26"
                     fill="none"
                     xmlns="http://www.w3.org/2000/svg"
                  >
                     <path
                        d="M70.3214 4.50391C76.2245 4.50391 81.0099 9.28915 81.0099 15.192L81.0098 15.1923L81.0099 15.1924L81.0082 25.8805L76.3862 25.8798L76.3864 23.9938C74.6632 25.1834 72.5737 25.8802 70.3214 25.8802C64.4182 25.8802 59.6328 21.0949 59.6328 15.192C59.6328 9.28915 64.4182 4.50391 70.3214 4.50391ZM64.2549 15.192C64.2549 18.5423 66.9709 21.2583 70.3214 21.2583C73.6718 21.2583 76.3878 18.5423 76.3878 15.192C76.3878 11.8418 73.6718 9.1258 70.3214 9.1258C66.9709 9.1258 64.2549 11.8418 64.2549 15.192Z"
                        fill="currentColor"
                     />
                     <path
                        d="M93.9546 4.62109C93.1244 4.62109 92.3136 4.71727 91.5338 4.90003C86.8196 6.00482 83.3238 10.2517 83.3238 15.3092L83.3255 25.9977L87.9476 25.997L87.9459 15.3092C87.9459 12.4253 89.9374 10.0213 92.5884 9.39995C93.0251 9.29761 93.4821 9.24299 93.9546 9.24299H96.2656V4.62109H93.9546Z"
                        fill="currentColor"
                     />
                     <path
                        d="M38.9503 15.192C38.9503 11.8418 36.2343 9.1258 32.8839 9.1258C29.5334 9.1258 26.8174 11.8418 26.8174 15.192C26.8174 18.5423 29.5334 21.2583 32.8839 21.2583C36.2343 21.2583 38.9503 18.5423 38.9503 15.192ZM43.5724 15.192C43.5724 21.0949 38.787 25.8802 32.8839 25.8802C26.9807 25.8802 22.1953 21.0949 22.1953 15.192C22.1953 9.28915 26.9807 4.50391 32.8839 4.50391C38.787 4.50391 43.5724 9.28915 43.5724 15.192Z"
                        fill="currentColor"
                     />
                     <path
                        d="M15.4953 4.50391L15.5809 4.50447C19.1876 4.54962 21.2334 7.44761 21.2517 10.201C21.2668 12.4903 19.916 14.8299 17.1644 15.656L5.42302 19.181C5.02004 19.3019 4.84688 19.4927 4.75858 19.6444C4.65406 19.824 4.59979 20.0752 4.64224 20.3545C4.68467 20.6338 4.81227 20.8643 4.97299 21.0129C5.11086 21.1403 5.34192 21.2748 5.76674 21.2748H20.0965V25.9013H5.76663C-0.733915 25.9012 -2.34812 16.6842 4.09763 14.7491L15.839 11.2243C16.2031 11.115 16.3747 10.9497 16.4658 10.8197C16.5684 10.6733 16.6357 10.4723 16.6341 10.2318C16.6321 9.91963 16.5145 9.63315 16.3418 9.44517C16.204 9.29511 15.9741 9.14035 15.5382 9.13082L15.4953 9.13037H2.31905V4.50391H15.4953Z"
                        fill="currentColor"
                     />
                     <path
                        d="M114.983 4.60156L114.898 4.60213C111.291 4.64728 109.245 7.54526 109.227 10.2987C109.212 12.5879 110.563 14.9276 113.314 15.7537L125.055 19.2786C125.458 19.3996 125.632 19.5903 125.72 19.7421C125.824 19.9217 125.879 20.1728 125.836 20.4522C125.794 20.7314 125.666 20.962 125.506 21.1106C125.368 21.238 125.137 21.3725 124.712 21.3725H110.382V25.999H124.712C131.212 25.9989 132.827 16.7819 126.381 14.8468L114.639 11.3219C114.275 11.2126 114.104 11.0474 114.013 10.9173C113.91 10.7709 113.843 10.5699 113.844 10.3294C113.846 10.0173 113.964 9.73081 114.137 9.54282C114.275 9.39277 114.504 9.23801 114.94 9.22848L114.983 9.22803H128.159V4.60156H114.983Z"
                        fill="currentColor"
                     />
                     <path
                        d="M49.219 17.7919V9.1258H43.4414V4.50391H59.6187V9.1258H53.8411V17.7919C53.8411 19.7063 55.3931 21.2583 57.3076 21.2583H59.6187V25.8802H57.3076C52.8404 25.8802 49.219 22.2589 49.219 17.7919Z"
                        fill="currentColor"
                     />
                     <path
                        d="M104.455 0C106.05 0 107.343 1.29331 107.343 2.88869C107.343 4.48406 106.05 5.77737 104.455 5.77737C104.218 5.77737 103.988 5.74886 103.767 5.6951C103.306 5.58253 102.735 5.88336 102.735 6.35804V17.9099C102.735 19.8243 104.287 21.3763 106.202 21.3763H108.513V25.9982H106.202C101.735 25.9982 98.1133 22.3769 98.1133 17.9099V4.6219H100.987C101.463 4.6219 101.765 4.04675 101.65 3.5844C101.595 3.36158 101.566 3.12855 101.566 2.88869C101.566 1.29331 102.859 0 104.455 0Z"
                        fill="currentColor"
                     />
                  </svg>
               </a>
            </p>
         </div>
      </footer>
   );
}

export default Footer;
